import { render, staticRenderFns } from "./BrandSwitching.vue?vue&type=template&id=48591837&scoped=true&"
import script from "./BrandSwitching.vue?vue&type=script&lang=js&"
export * from "./BrandSwitching.vue?vue&type=script&lang=js&"
import style0 from "./BrandSwitching.vue?vue&type=style&index=0&id=48591837&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48591837",
  null
  
)

export default component.exports